module.exports = __webpack_public_path__ + "img/snow_fall_00031.b48dab60.png";